import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@sourceflow/offices.json";

export const useOffices = () => useSourceFlowCollection(data);

export default useOffices;
